var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(" Hier können Sie sich den Arbeitsergebnissen von "),_c('em',[_vm._v("Beethovens Werkstatt")]),_vm._v(" anhand der projektinternen Untergliederung in fünf aufeinander aufbauende Module annähern. Dabei handelt es sich um die identischen Fallbeispiele aus Beethovens Werken, allerdings erfolgt der Zugriff der Projektchronologie folgend. ")])])
}]

export { render, staticRenderFns }